/**
 * DevExtreme (viz/circular_gauge.js)
 * Version: 19.2.6
 * Build date: Thu Jan 30 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
module.exports = require("./gauges/circular_gauge");
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// ./~/devextreme/viz/circular_gauge.js
// module id = 1326
// module chunks = 0